import { useState, useEffect, useRef } from "react";
import { useSearchParams, useParams, useNavigate } from "react-router-dom";
import { getAffirmationSuggestion } from "../../../services/api";
import Notiflix from "notiflix";

export default function AffirmationSuggestionSingle() {
  const [suggestionData, setSuggestionData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [isTextVisible, setIsTextVisible] = useState(false);
  const [progress, setProgress] = useState(0);
  const [isStarted, setIsStarted] = useState(false);
  const audioRef = useRef(null);
  const textTimeoutRef = useRef(null);
  const [searchParams] = useSearchParams();
  const { id, moduleId } = useParams();
  const slug = searchParams.get("slug");
  const navigate = useNavigate();
  // Notiflix'i initialize et
  useEffect(() => {
    Notiflix.Notify.init({
      position: "top-right",
      timeout: 3000,
      clickToClose: true,
      pauseOnHover: true,
    });
  }, []);

  // Slug'a göre veriyi fetch et
  useEffect(() => {
    const fetchSuggestion = async () => {
      if (!slug) {
        Notiflix.Notify.failure("Kategori bulunamadı!");
        return;
      }

      try {
        setLoading(true);
        const response = await getAffirmationSuggestion(slug);
        setSuggestionData(response.category);
      } catch (error) {
        console.error("Olumlama önerisi alınırken hata:", error);
        Notiflix.Notify.failure("Veri yüklenirken bir hata oluştu!");
      } finally {
        setLoading(false);
      }
    };

    fetchSuggestion();
  }, [slug]);

  // Başlat butonuna tıklandığında hem müziği hem metinleri başlat
  const handleStart = async () => {
    setIsStarted(true);
    
    try {
      // Müziği başlat
      if (suggestionData?.audio_url && audioRef.current) {
        await audioRef.current.play();
        console.log("Müzik başlatıldı");
      }
      
      // Metin sırasını başlat
      startTextSequence();
    } catch (error) {
      console.error("Müzik çalınamadı:", error);
      // Müzik çalınamazsa yine de metinleri göster
      startTextSequence();
    }
  };

  // Metin sırasını başlat
  const startTextSequence = () => {
    if (!suggestionData?.details || suggestionData.details.length === 0) return;

    setCurrentTextIndex(0);
    setIsTextVisible(true);
    setProgress(0);

    // İlk metni göster
    showText(0);
  };

  // Belirli bir metni göster
  const showText = (textIndex) => {
    if (!suggestionData?.details || textIndex >= suggestionData.details.length)
      return;

    const currentDetail = suggestionData.details[textIndex];
    const duration = parseFloat(currentDetail.duration) * 60 * 1000; // dakika -> saniye -> ms


    // Progress bar animasyonu
    let progress = 0;
    const progressInterval = setInterval(() => {
      progress += 2; // Her 200ms'de %2 artır
      setProgress(Math.min(progress, 100));

      if (progress >= 100) {
        clearInterval(progressInterval);
      }
    }, duration / 50); // Sürenin 1/50'si kadar interval

    // Metni gizle ve sonraki metne geç
    textTimeoutRef.current = setTimeout(() => {
      setIsTextVisible(false);
      setProgress(0);

      setTimeout(() => {
        if (textIndex < suggestionData.details.length - 1) {
          // Sonraki metne geç
          setCurrentTextIndex(textIndex + 1);
          setIsTextVisible(true);
          showText(textIndex + 1);
        } else {
          // Tüm metinler bitti
          console.log("Tüm metinler bitti");
        }
      }, 500);
    }, duration);
  };

  // Cleanup
  useEffect(() => {
    return () => {
      if (textTimeoutRef.current) {
        clearTimeout(textTimeoutRef.current);
      }
    };
  }, []);

  if (loading) {
    return (
      <div className="w-full h-screen min-h-screen flex items-stretch justify-stretch sm:items-center sm:justify-center bg-[#e8e9ed]">
        <div className="flex flex-col items-center w-full min-h-full bg-white shadow-xl border border-gray-200 rounded-none sm:max-w-[390px] sm:h-[700px] sm:rounded-3xl relative overflow-y-auto">
          <div className="flex-1 flex items-center justify-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#3DA7B5]"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className= "w-full h-screen min-h-screen flex flex-col items-stretch justify-stretch sm:items-center sm:justify-center relative"
      style={{
        backgroundImage: "url(/assets/pngImages/astronomy.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Arka plan kaplama */}
      <div className="flex p-4 text-white  items-center gap-2">
          <button
            onClick={() => navigate(-1)}
            className="w-8 h-8 text-white flex items-center justify-center "
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <div>
            <p className="text-lg font-semibold">Olumlama Telkini</p>
          </div>
        </div>
      <div className="flex flex-col items-center w-full h-[calc(100vh-100px)] rounded-none sm:max-w-[390px] sm:rounded-3xl relative overflow-hidden">
        {/* Arka plan müziği */}
        {suggestionData?.audio_url && (
          <audio
            ref={audioRef}
            src={suggestionData.audio_url}
            loop
            preload="auto"
            className="hidden"
          />
        )}

        {/* Ana İçerik */}
        <div className="flex-1 w-full flex flex-col items-center justify-center px-6 relative z-10">
          
          {/* Başlat Butonu - Sadece başlamadan önce göster */}
          {!isStarted && (
            <div className="text-center mb-8">
           
              <button
                onClick={handleStart}
                className="px-12 py-4 bg-gradient-to-r from-[#3DA7B5] to-[#2A8B96] text-white rounded-2xl font-bold text-xl shadow-2xl hover:shadow-3xl transform hover:scale-105 transition-all duration-300 active:scale-95"
              >
                 Başlat
              </button>
            </div>
          )}

          {/* Metin Gösterim Alanı - Sadece başladıktan sonra göster */}
          {isStarted && (
            <div className="w-full max-w-sm mb-8">
            <div className=" text-white backdrop-blur-sm rounded-3xl p-8 shadow-2xl relative overflow-hidden border border-white/30">
              {/* Arka plan deseni */}
              <div className="absolute inset-0 opacity-10">
                <div className="absolute top-4 left-4 w-8 h-8 border-2 border-[#3DA7B5] rounded-full"></div>
                <div className="absolute top-8 right-8 w-4 h-4 bg-[#3DA7B5] rounded-full"></div>
                <div className="absolute bottom-8 left-8 w-6 h-6 border-2 border-[#3DA7B5] rounded-full"></div>
                <div className="absolute bottom-4 right-4 w-3 h-3 bg-[#3DA7B5] rounded-full"></div>
              </div>

              {/* Metin */}
              <div className="relative z-10 text-center">
                {isTextVisible &&
                  suggestionData?.details &&
                  suggestionData.details[currentTextIndex] && (
                    <div className="animate-fade-in-up">
                        <p className="text-gray-100 text-2xl font-semibold leading-relaxed font-aclonica">
                          {suggestionData.details[currentTextIndex].text}
                        </p>
                    </div>
                  )}
              </div>

              {/* Progress Bar */}
              <div className="absolute bottom-0 left-0 right-0 h-2 bg-[#3DA7B5]/20 rounded-b-3xl">
                <div
                  className="h-full bg-gradient-to-r from-[#3DA7B5] to-[#2A8B96] transition-all duration-100 ease-linear rounded-b-3xl"
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
            </div>

  
          </div>
          )}
        </div>

        {/* Alt Boşluk */}
        <div className="h-20"></div>
      </div>

      <style jsx>{`
        @import url('https://fonts.googleapis.com/css2?family=Aclonica&display=swap');
        
        @keyframes fade-in {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fade-in {
          animation: fade-in 1s ease-in-out;
        }

        .animate-fade-in-up {
          animation: fade-in-up 0.5s ease-out;
        }
        
        .font-aclonica {
          font-family: 'Aclonica', cursive;
        }
      `}</style>
    </div>
  );
}
